import I18n from '../../../config/i18n';
import Formatter from '../../../utils/Formatter';

import './CheckoutTime.css';

interface CheckoutTimeProps {
  checkin?: string;
  checkout?: string;
}

export default function CheckoutTime({ checkin, checkout }: CheckoutTimeProps): JSX.Element | null {
  if (!checkin || !checkout) {
    return null;
  }
  return (
    <div className="checkouttime">
      {I18n.t('price.check_in')} {Formatter.time(checkin)}, {I18n.t('price.check_out')}{' '}
      {Formatter.time(checkout)}
    </div>
  );
}

const defaultProps: Pick<CheckoutTimeProps, 'checkin' | 'checkout'> = {
  checkin: undefined,
  checkout: undefined,
};

CheckoutTime.defaultProps = defaultProps;
